<template>
  <div v-if="filters" class="layer">
    <button type="button" class="btnClose" @click="cancel"><span class="blind">close</span></button>
    <div class="inner">
      <h2 class="layerTitle">{{locale.title_plu_search}}</h2>
      <div class="search">
        <select v-if="filters" class="input select inlineInput" v-model="filter">
          <option v-for="method in filters" :key="method" :value="method">{{ getMethodName(method) }}</option>
        </select>
        <input type="text" ref="searchPluInput" class="input" v-model="search" @keyup.enter="searchPlu">
        <button type="button" class="btn btnWhite sizeS btnSearch" @click="searchPlu"></button>
      </div>
      <div class="items">
        <div v-if="!items" class="message">{{locale.message_plu_search}}</div>
        <div v-else-if="items.length">
          <p class="sysMessage mb5">{{locale.message_toggle_apply_item}}</p>
          <table>
            <thead class="th">
              <tr>
                <th><span class="checkbox"></span></th>
                <th class="code" :class="{notApply: !applyList.includes('itemCode')}" @click="applyItem('itemCode')">{{ locale.product_id }}</th>
                <th class="name" :class="{notApply: !applyList.includes('name')}" @click="applyItem('name')">{{ locale.name }}</th>
                <th class="amount" :class="{notApply: !applyList.includes('amount')}" @click="applyItem('amount')">{{ locale.price }}</th>
                <th v-if="optionField">
                  <div class="etc">
                    <span v-for="(opt, i) in optionField"
                      :key="i"
                      class="opt">
                      {{ opt.name }}
                    </span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in items"
                :key="index">
                <td>
                  <span class="checkbox radio">
                    <input type="radio" :id="`${index}_plu_${item.itemCode}`" :value="item.itemCode" @change="setItem(index)">
                    <label :for="`${index}_plu_${item.itemCode}`" class="label"></label>
                  </span>
                </td>
                <td class="code" :class="{notApply: !applyList.includes('itemCode')}">{{ item.itemCode || '-' }}</td>
                <td class="name" :class="{notApply: !applyList.includes('name')}">{{ item.itemName || '-' }}</td>
                <td class="amount" :class="{notApply: !applyList.includes('amount')}">{{ item.amount || 0 }}</td>
                <td v-if="item.optionField">
                  <div class="etc">
                    <span v-for="(opt, i) in item.optionField"
                      :key="i"
                      class="opt">
                      {{ opt.value || '-' }}
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else class="message">{{locale.message_search_nodata}}</div>
      </div>
      <div class="btns">
        <button type="button" class="btn btnFull btnPrimary" @click="apply">{{ locale.apply }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import LANG from '@/common/lang'
import regExp from '@/common/regExp'

export default {
  name: 'Plu',
  props: [
    'locale',
    'pluData',
    'orderType'
  ],
  computed: {
    filters () {
      return this.$store.getters['util/getSupportPlu']
    },
    filter: {
      get () {
        return this.$store.getters['util/getPluMethod']
      },
      set (filter) {
        this.$store.commit('util/setPluMethod', filter)
      }
    },
    optionField () {
      const items = this.items
      return items.find(x => x.optionField) && items.find(x => x.optionField).optionField
    }
  },
  mounted () {
    const pluData = this.pluData
    // if (this.getSupportPlu) {
    //   this.filters = res
    // }
    this.$nextTick(() => {
      if (this.$refs.searchPluInput) {
        this.$refs.searchPluInput.focus()
      }
    })
    if (pluData) {
      this.plu = this._.cloneDeep(pluData)
    } else {
      alert(this.locale.data_not_found)
      this.onClose()
    }
  },
  data () {
    return {
      search: '',
      plu: null,
      items: null,
      applyList: [
        'itemCode',
        'name',
        'amount'
      ]
    }
  },
  methods: {
    searchPlu () {
      const method = this.filter
      const value = this.search
      const orderType = this.orderType
      this.$store.commit('onLoading', true)
      this.items = null
      if (regExp.replaceAllEmpty(value).length > 0) {
        this.$store.dispatch('util/getPluItems', {
          method: method,
          value: value,
          ...orderType && {
            orderType: orderType
          }
        }).then((res) => {
          if (res) {
            if (res.status === 405 && res.message === 'orderType') {
              alert(this.locale.alert_plu_ordertype)
            } else {
              this.items = res.items.map(x => {
                return {
                  ...x,
                  active: false
                }
              })
            }
          } else {
            alert(this.locale.unknown_error)
          }
        })
        this.$store.commit('onLoading', false)
      } else {
        alert(this.locale.alert_input_search)
        this.search = ''
        this.$store.commit('onLoading', false)
      }
    },
    applyItem (item) {
      const isApply = this.applyList.includes(item)
      this.applyList = isApply
        ? this.applyList.filter(i => i !== item)
        : [ ...this.applyList, item ]
    },
    setItem (index) {
      if (this.plu) {
        if (this.items) {
          const item = this.items.find((x, i) => i === index)
          this.items = this.items.map((x, i) => {
            return {
              ...x,
              active: i === index
            }
          })
          this.plu = {
            ...this.plu,
            ...item.itemCode && {
              pIdActive: true,
              pId: item.itemCode
            },
            ...item.itemName && {
              value: item.itemName,
              label: LANG.valueObj(item.itemName)
            },
            ...item.amount && {
              price: item.amount
            }
          }
        } else {
          alert(this.locale.alert_search_plu_nodata)
        }
      } else {
        alert(this.locale.alert_plu_product_nodata)
      }
    },
    getMethodName (method) {
      let result = method
      switch (method) {
        case 'code':
          result = this.locale.product_id
          break
        case 'name':
          result = this.locale.name
          break
      }
      return result
    },
    apply () {
      const activeItem = this.items.find(x => x.active)
      if (activeItem) {
        if (window.confirm(this.locale.confirm_apply)) {
          this.plu = {
            ...this.plu,
            pIdActive: this.applyList.includes('itemCode') ? this.plu.pIdActive : this.pluData.pIdActive,
            pId: this.applyList.includes('itemCode') ? this.plu.pId : this.pluData.pId,
            value: this.applyList.includes('name') ? this.plu.value : this.pluData.value || this.pluData.pName, // page: value, product: pName
            label: this.applyList.includes('name') ? this.plu.label : this.pluData.label || this.pluData.name, // page: label, product: name
            price: this.applyList.includes('amount') ? this.plu.price : this.pluData.price
          }
          this.$emit('apply', this.plu)
        }
      } else if (!this.items) {
        alert(this.locale.alert_plu_search)
      } else {
        alert(this.locale.alert_plu_apply)
      }
    },
    cancel () {
      if (window.confirm(this.locale.confirm_cancel)) {
        this.onClose()
      }
    },
    onClose () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
@mixin check {
  content: "\2713";
  margin-right: 4px;
  font-family: 'sans-serif';
  font-weight: bold;
  color: $color-green;
}
.layer {
  .inner {
    max-width: 800px;
  }
}
.search {
  display: flex;
  margin-bottom: 15px;
  .input {
    border-color: $color-lgrey2;
  }
  .select {
    margin-right: 4px;
  }
  .btnSearch {
    position: relative;
    width: 40px;
    align-self: stretch;
    &:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: url('~@/assets/img/ico_search.svg') 50% 50% / 18px no-repeat;
      opacity: 0.3;
    }
  }
}
.message {
  text-align: center;
  font-size: 1.2em;
}
.items {
  table {
    border-left: 1px solid $color-lgrey2;
    border-right: 1px solid $color-lgrey2;
    background-color: $color-white;
  }
  th,
  td {
    padding: 10px;
    text-align: left;
    border-top: 1px solid $color-lgrey2;
    border-bottom: 1px solid $color-lgrey2;
    &:first-of-type {
      width: 40px;
    }
  }
  .checkbox {
    margin: 0;
  }
  th {
    padding: 15px 10px;
  }
  .th {
    .code,
    .name,
    .amount {
      cursor: pointer;
      &:before {
        @include check;
      }
    }
    .notApply:before {
      color: $color-grey;
    }
  }
  .notApply {
    opacity: 0.5;
  }
  .etc {
    display: flex;
    text-align: center;
    padding: 0;
    .opt {
      flex: 1;
      padding: 10px;
    }
  }
}
.btns {
  width: 180px;
  margin: 30px auto 0;
}
</style>
